/**
 * 应用常量
 */

// 请求状态码
export const HTTP_STATUS = {
    SUCCESS: 200,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403, // 403 无权限访问
    NOT_FOUND: 404,
    NOT_ACCEPTABLE: 406,
    REQUEST_TIMEOUT: 408,
    SERVER_ERROR: 500,
    BAD_GATEWAY: 502,
    SERVICE_UNAVAILABLE: 503,
    GATEWAY_TIMEOUT: 504,
} as const;

/**
 * 请求结果状态码
 */
export const STATUS_CODE = {
    SUCCESS: 0,
    /* 项目不存在（已删除项目链接再次打开） */
    PROJECT_NOT_FOUND: 1402,
    /* AcsToken 反作弊状态码 */
    /* 请求限流 */
    ACS_TOKEN_RATE_LIMITED: 110002,
    /* 账号异常，命中黑名单 */
    ACS_TOKEN_ACCOUNT_BLOCKED: 110003,
    /* 命中玉门关，需要弹验证码 */
    ACS_TOKEN_CAPTCHA_REQUIRED: 110004,
    /* 命中玉门关，拦截 */
    ACS_TOKEN_RISK_BLOCKED: 110005,
    // 画布版本冲突
    CONFLICT_STATUS: 1310,
    /* 剧本未更新 */
    SCRIPT_NOT_UPDATED: 931,
    /* 查询剧本失败 */
    SCRIPT_QUERY_FAILED: 909,
    /* 剧本未确认 */
    SCRIPT_NOT_CONFIRMED: 930,
    /* 剧本编辑冲突（无编辑权限） */
    SCRIPT_EDIT_CONFLICT_STATUS: 935,
    /* 内容风控 */
    // TODO 还未确定，后续确定错误码后  替换
    CONTENT_RISK: 10000,
    /* 积分不足 */
    CREDIT_INSUFFICIENT: 20035,
    /* 权益等级不够（会员等级不支持该能力） */
    BENEFIT_NOT_ALLOWED: 2100,
    /* 权益配额超限（比如成员数超过权益配额） */
    BENEFIT_QUOTA_EXCEEDED: 2101,
};

/**
 * 错误消息常量映射表
 */
export const ERROR_MESSAGES = {
    DEFAULT_ERROR_MESSAGE: '请求失败，请稍后重试',
    ACS_TOKEN_STATUS_MESSAGE: '账号状态异常，请稍后再试',
    REQUEST_TIMEOUT_MESSAGE: '请求超时，请稍后重试',
    LOAD_FAILED_MESSAGE: '加载失败，请重试',
    PERMISSION_FETCH_FAILED: '权限获取失败',
    PERMISSION_NO_ACCESS: '无访问权限',
    PERMISSION_NO_OPERATION: '无操作权限，系统已自动同步最新权限状态',
} as const;

/** 主内容区滚动容器 ID，用于工作台 InfiniteScroll 绑定滚动目标 */
export const PAGE_CONTENT_SCROLL_ID = 'pageContent';

/** 剪辑器入口地址，使用当前页面所在域名，便于不同测试环境间切换 */
export const EDITOR_BASE_URL =
    typeof window !== 'undefined' ? window.location.origin : 'https://mangaflow.now.baidu.com'; // SSR 环境使用生产域名兜底 // 改成正式的线上域名

/** 用户手册地址 */
export const USER_MANUAL_URL =
    'https://ku.baidu.com/knowledge/HFVrC7hq1Q/71hcslwy02/Aubjbpk9tp/dopQfOvDeN6pnD';

// 智能星星加载
export const aiStarGif =
    'https://now.bdstatic.com/stash/v1/01e9009/mangaflow-fe/9896fde/workspace/smartLoading.gif';

// 普通星星加载
export const baseStarGif =
    'https://now.bdstatic.com/stash/v1/01e9009/mangaflow-fe/9896fde/workspace/grayLoading.gif';

// 音频占位图
export const audioCover =
    'https://now.bdstatic.com/stash/v1/01e9009/mangaflow-fe/9896fde/canvas/resource/audio_cover_new.png';

// 剧本上传默认占位图
export const defaultImgUrl =
    'https://now.bdstatic.com/stash/v1/01e9009/mangaflow-fe/9896fde/script/5a544199c7c734ed2b2021d9f.png';

// 剧本积分消耗规则图
export const ruleImgUrl =
    'https://now.bdstatic.com/stash/v1/01e9009/mangaflow-fe/9896fde/script/57b387f863c508956d8b3b2dc.png';

// 音频图标
export const audioIcon =
    'https://now.bdstatic.com/stash/v1/01e9009/mangaflow-fe/9896fde/common/audio-icon.png';
